/**
 * Created by piotr.pozniak@thebeaverhead.com on 02/09/2022.
 */

import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import * as subscriptionActions from "../../actions/subscription";

export function useSubscriptionStore() {
  const dispatch = useDispatch();
  const _subscription = useSelector((store) => store.subscription);

  const createStripeCheckoutSession = useCallback(
    async (stripePriceId) =>
      await dispatch(subscriptionActions.createStripeSession(stripePriceId)),
    [dispatch]
  );

  const fetchCustomerPortalLink = useCallback(
    async (flow) =>
      await dispatch(subscriptionActions.fetchCustomerPortalLink(flow)),
    [dispatch]
  );

  const fetchCustomerSession = useCallback(
    async (stripePriceId, selectedPlan, referralCoupon) =>
      await dispatch(
        subscriptionActions.fetchCustomerSession(
          stripePriceId,
          selectedPlan,
          referralCoupon
        )
      ),
    [dispatch]
  );

  const createPaymentLink = useCallback(
    async (stripePriceId, selectedPlan, referralCoupon) =>
      await dispatch(
        subscriptionActions.createPaymentLink(
          stripePriceId,
          selectedPlan,
          referralCoupon
        )
      ),
    [dispatch]
  );

  return {
    subscription: _subscription,
    createStripeCheckoutSession,
    fetchCustomerPortalLink,
    createPaymentLink,
    fetchCustomerSession,
  };
}
